module.exports = __webpack_public_path__ + "img/beer_id-59.9212be31.png";